export enum DriveType {
  FRONT_WHEEL_DRIVE = 'FRONT_WHEEL_DRIVE',
  REAR_WHEEL_DRIVE = 'REAR_WHEEL_DRIVE',
  ALL_WHEEL_DRIVE = 'ALL_WHEEL_DRIVE',
}
